import { ESegmentToolkit } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/types';
import type { TBroadcastScheduleProgramContextState } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';

/**
 * Mirrors when the Logos and People panels render their form instead of their table.
 * If a panel changes that rule, or a new presence form or tab is added, update it here.
 */
function isPresenceFormOnScreen(
  formBox: TBroadcastScheduleProgramContextState['formBox'],
  pinnedId: ESegmentToolkit | null,
  isGlobalView: boolean
): boolean {
  if (isGlobalView) return false;

  return (
    (formBox === 'logo' && pinnedId === ESegmentToolkit.LOGOTIPO) ||
    (formBox === 'people' && pinnedId === ESegmentToolkit.PERSONAS)
  );
}

export { isPresenceFormOnScreen };
